import { render, staticRenderFns } from "./b-menu.vue?vue&type=template&id=127a35d4&scoped=true&"
import script from "./b-menu.vue?vue&type=script&lang=js&"
export * from "./b-menu.vue?vue&type=script&lang=js&"
import style0 from "./b-menu.vue?vue&type=style&index=0&id=127a35d4&lang=scss&scoped=true&"
import style1 from "./b-menu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a35d4",
  null
  
)

export default component.exports